import { Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import BookingApi from "../../../API/Apis/BookingApi";
import { t } from "i18next";
import { ArrowDropDownOutlined } from "@mui/icons-material";
import { createTheme, Theme, ThemeProvider } from "@mui/material/styles";
import theme, {
  formatThemeForReservedArea,
} from "../../../config/MuiColorThemes";
import { useLocation } from "react-router-dom";

function BookingDetailsListSideNavigation() {
  const location = useLocation();
  const [dynamicTheme, setDynamicTheme] = useState<Theme | null>(null);
  const [userData, setUserData] = useState<any>({});
  const navigateTo = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const isActiveProfileSection =
    location.pathname === "/profile" || location.pathname === "/changePassword";

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };
  useEffect(() => {
    async function fetchTheme() {
      const dynamicPalette = await formatThemeForReservedArea();
      const newTheme = createTheme(dynamicPalette);
      setDynamicTheme(newTheme);
    }
    fetchTheme();
  }, []);

  useEffect(() => {
    const id = localStorage.getItem("userID");
    if (id) {
      BookingApi.getUserProfileByUserId(Number(id)).then((res) => {
        setUserData(res.data.onlineUser[0]);
      });
    }
  }, []);

  const handleLogout = () => {
    localStorage.setItem("isUserLoggedin", "false");
    localStorage.removeItem("userID");
    localStorage.removeItem("customerId");
    navigateTo("/signin");
  };
  return (
    <ThemeProvider theme={dynamicTheme || theme}>
      <div
        className="text-[#000] p-12 shadow-[5px_0px_16px_3px_#00000024]"
        style={{ height: "100vh" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            marginLeft: "10px",
          }}
        >
          <ul className="gap-4 mt-4 flex-wrap">
            <li>
              <Avatar
                alt={userData.firstName}
                src={
                  userData.profile_picture
                    ? userData.profile_picture
                    : userData.firstName
                }
              />
            </li>
          </ul>
          <div className="mt-2 text-center">
            {`${userData.firstName || ""} ${userData.lastName || ""}`}
          </div>
        </div>
        <hr />
        <div className="nav-section">
          <ul className="nav-list">
            <li style={{ padding: "4px" }}>
              <NavLink
                to="/"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/createBooking.png"
                  alt="Create Booking"
                />
                {t("CreateBooking")}
              </NavLink>
            </li>
            <li style={{ padding: "4px" }}>
              <NavLink
                to="/customerDetailsList"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/customer.details.png"
                  alt="Customer Details"
                />
                {t("Customer Details")}
              </NavLink>
            </li>
            <li style={{ padding: "4px" }}>
              <NavLink
                to="/myReservedBookings"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/bookingicon.png"
                  alt="List of reservation"
                />
                {t("List of reservation")}
              </NavLink>
            </li>
            <li style={{ padding: "4px" }}>
              <NavLink
                to="/myInvoices"
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/invoiceicon.png"
                  alt="List of invoice"
                />
                {t("List of invoice")}
              </NavLink>
            </li>

            <li style={{ padding: "4px" }}>
              <ul className="flex flex-col gap-6 text-base">
                <li
                  onClick={toggleDropdown}
                  className={`nav-item flex items-center gap-2 ${
                    isActiveProfileSection ? "active" : ""
                  }`}
                >
                  <img
                    className="h-5 cursor-pointer"
                    src="/assets/images/profile.png"
                    alt="Profile"
                  />
                  {t("My Profile")}
                  <ArrowDropDownOutlined style={{ color: "black" }} />
                </li>

                {isDropdownOpen && (
                  <>
                    <li style={{ marginLeft: "35px", padding: "4px" }}>
                      <NavLink
                        to="/profile"
                        className={({ isActive }) =>
                          isActive ? "nav-item active" : "nav-item"
                        }
                      >
                        {t("Personal information")}
                      </NavLink>
                    </li>
                    <li style={{ marginLeft: "35px", padding: "4px" }}>
                      <NavLink
                        to="/changePassword"
                        className={({ isActive }) =>
                          isActive ? "nav-item active" : "nav-item"
                        }
                      >
                        {t("Change password")}
                      </NavLink>
                    </li>
                  </>
                )}
              </ul>
            </li>

            <li style={{ padding: "4px" }}>
              <NavLink
                to="/signin"
                onClick={handleLogout}
                className={({ isActive }) =>
                  isActive ? "nav-item active" : "nav-item"
                }
              >
                <img
                  className="h-6"
                  src="/assets/images/logout.png"
                  alt="Logout"
                />
                {t("Logout")}
              </NavLink>
            </li>
          </ul>
        </div>
      </div>
    </ThemeProvider>
  );
}

export default BookingDetailsListSideNavigation;
